import api from '../api'

const state = {
  all: []
}

const actions = {
  getUserDownloads: ({ state, commit }) => {
    return api.getUserDownloads().then(downloads => {
      return commit('setAllDownloads', downloads)
    })
  },
  getCreativeDownloads: ({ state, commit }, id) => {
    return api.getCreativeDownloads(id).then(downloads => {
      return commit('setAllDownloads', downloads)
    })
  },
  getDownload: ({ state, commit }, id) => {
    return api.getDownload(id)
  },
  createSignedDownloadRequest: ({ state, commit }, payload) => {
    return api.createSignedDownloadRequest(payload)
  },
  processDownload: ({ state, commit }, data) => {
    return api.processDownload(data)
  }
}

const mutations = {
  setAllDownloads (state, downloads) {
    state.all = downloads
  }
}

const getters = {
  all: state => {
    return state.all
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/downloads.js